export default __webpack_public_path__ + "static/media/about-info.bb7bf531.jpg";